import { render, staticRenderFns } from "./group-rules.vue?vue&type=template&id=b9d5ec62&scoped=true&"
import script from "./group-rules.vue?vue&type=script&lang=js&"
export * from "./group-rules.vue?vue&type=script&lang=js&"
import style0 from "./group-rules.vue?vue&type=style&index=0&id=b9d5ec62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d5ec62",
  null
  
)

export default component.exports